import React, { useState, useEffect, PropTypes, createRef } from "react"
import { defaultArea } from "@constants";
import { get, find, isEmpty } from "lodash"
import { Link } from "gatsby"
import classNames from "classnames"
import GlobalContext from '../components/context/GlobalContext';
import Select from "react-select"
import Layout from "@components/layout";
// import { Dropdown, ButtonGroup } from "react-bootstrap"
import { Col, Container, Row, Form } from "react-bootstrap"
import Button from "../components/button/button"
import $ from "jquery"
import qs from "qs"
// import "@components/SearchResult/SearchMenu.scss"
// import Slider from "react-slick"
// import SearchList from "@components/SearchResult/SearchList"
import NoResultList from "@components/SearchResult/NoResultList"
import Modal from 'react-bootstrap/Modal';
import "../components/news-lettings/styles/_index.scss"
import LinkIcon from "../components/link-icon/link-icon"
import FieldSelect from "../components/field-select/field-select"
import SearchAuctionListItems from "@components/SearchResult/SearchAuctionListItems"
import { toTitleCase, makeLowerCaseExceptArea } from "@components/common/site/utils";
import { v4 as uuidv4 } from "uuid"
import { includes } from "lodash";
// import { isMobileTab, isMobile } from "../jsutility/";
import {
  isTablet,
  isIPad13,
  isIOS13,
  isMobile,
  isMobileOnly,
  isDesktop,
  browserName,
} from "react-device-detect"

import SeoResults from "@components/common/site/seoResults"
import {
  ACTION_TYPES,
  ACTION_DESC_TYPES,
  getPriceStr,
} from "@components/common/site/utils"
import FloorPlanModal from "@components/SearchResult/floorPlanModal"
import VideoPlay from "@components/Play/property-results-video"
import algoliasearch from "algoliasearch/lite"
import {
  parseSearchUrl,
  propertyH1,
  savedSearchParams,
} from "@components/common/site/utils"
import Cookies from "universal-cookie"
import { navigate } from "@reach/router"
import Loadable from "@loadable/component"
import {
  bedOptions,
  buildingOptions,
  priceminRange,
  pricemaxRange,
  priceminRangeRentals,
  pricemaxRangeRentals,
  meterToMiles,
  milesToMeter,
  isAreaMatch,
} from "@components/SearchResult/filter/constant"
import RefineFilter from "@components/SearchResult/filter"
import FilterForm from "../blocks/filter-form/filter-form";
import SubscribetoCatalogueForm from "../Forms/SubscribetoCatalogue";
import moment from "moment";
import { getAuctionMonthFromPath, getAuctionMonthSegment } from "@utils/auctions/auction-groups";
import { stubFalse } from "lodash";
const MapResultsDesktop = Loadable(() =>
  import("@components/map/search-results-desktop-map")
)

const MobileResultsDesktop = Loadable(() =>
  import("@components/map/search-results-mobile")
)

const mycookies = new Cookies()
const updateAfter = 500

var minpriceval = minpriceval || ""
var maxpriceval = maxpriceval || ""
var minpricevalrentals = minpricevalrentals || ""
var maxpricevalrentals = maxpricevalrentals || ""
var includeSold = false
var includeLet = false


const searchClient = algoliasearch(
  "2YSJKJYDY4",
  "33ef03277df04d3dae79e0328d779b56"
)

// const index_name = `dev_properties`
const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`

// Capitalize
const capitalize = s => {
  if (typeof s !== "string") return ""
  return s.charAt(0).toUpperCase() + s.slice(1)
}
// Capitalize

let arrow = false
let filter = false

const myRef = createRef();

// Property results loop
const CustomInfiniteHits = ({
  hits,
  // hasPrevious,
  // refinePrevious,
  hasMore,
  // refineNext,
  location,
  tag,
  map,
  userObjects,
  page,
  auctionType
}) => {
  var url_main = typeof window !== 'undefined' ? window.location.pathname : ''
  var page = url_main.split("/").filter(c => c.includes("page-")).length > 0 ? url_main.split("/").filter(c => c.includes("page-"))[0].split("page-").map(c => c)[1] : 1
const refineNext = event => {
    var url_main = typeof window !== 'undefined' ? window.location.pathname : ''
    var pageCount = url_main.split("/").filter(c => c.includes("page-")).length > 0 ? url_main.split("/").filter(c => c.includes("page-"))[0].split("page-").map(c => c)[1] : 1
  
    let pageUrl = 'page-' + ((parseInt(page)+1)) + '/';
    //get current url
    const urlwithoutsort = (url_main).split("page-");
    // concat url and navigate
    navigate(urlwithoutsort[0] + pageUrl)
    myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "center" })

}

const refinePrevious = event => {
  var url_main = typeof window !== 'undefined' ? window.location.pathname : ''
  var pageCount = url_main.split("/").filter(c => c.includes("page-")).length > 0 ? url_main.split("/").filter(c => c.includes("page-"))[0].split("page-").map(c => c)[1] : 1

  let pageUrl = 'page-' + ((parseInt(page)-1)) + '/';
  //get current url
  const urlwithoutsort = (url_main).split("page-");
  // concat url and navigate
  navigate(urlwithoutsort[0] + pageUrl)
  myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })

}
  return (
    <>
     {hits?.length > 0 && parseInt(page) > 1 && (
            <Button
            className="btn--outline pre"
            color="tsp"
            id="mynextbut"
            borderColor="blue"
            textColor=""
            displayAsLink={false}
            onClick={refinePrevious}
            disabled={!hasMore}
          >
            <Button.Text>Load Previous properties</Button.Text>
          </Button>
    
        )} 
    
      {/* {hits.length > 0 && hasPrevious && (
      <button
        id="myprevbut"
        onClick={refinePrevious}
        disabled={!hasPrevious}
        className="d-none property_show_more_btn"
      >
        Show prev
      </button>
    )} */}
      <div className="news-lettings">
        <SearchAuctionListItems auctionType={auctionType} map={map} hits={hits} tag={tag} />
      </div>
      {/* <div className="justify-content-center main-pagination-container no-pad">
    <CustomPaginationRender pagenumber={parseInt(page)} />
    </div> */}
      {/*hits.map((hit, i) => {
      // property details url structure
      let uriStr = ""
      let mysale = ""

      if (hit.searchType === "sales" && hit.department === "residential") {
        uriStr = `property/for-sale-details/`
        mysale = `myResSaleProp`
      } else if (
        hit.searchType === "lettings" &&
        hit.department === "residential"
      ) {
        uriStr = `property-to-rent-details/`
        mysale = `myResRentProp`
      }

      if (tag === "sold") {
        uriStr = `property-sold/`
        mysale = `myResSaleProp`
      } else if (tag === "let") {
        uriStr = `property-let/`
        mysale = `myResRentProp`
      }

      let url_one = ""
      let photoplans = false

      if (hit.virtual_tour) {
        url_one = String(hit.virtual_tour)
        photoplans = url_one.indexOf("photoplans.planup") > -1
      }
      // property details url structure

      return (
        <div
          className="property-card mysingleproperty"
          id={`item${hit.objectID}`}
          data-objectid={hit.objectID}
          data-lat={hit?._geoloc?.lat}
          data-lng={hit?._geoloc?.lng}
        >
          {tag == "sold" || tag == "let" ? (
            <div className="result-tile">
              <div className="map-wrapper">
                <SearchList
                  images={hit.images}
                  floorplan={hit.floorplan}
                  virtual_tour={hit.virtual_tour}
                  Title={hit.display_address}
                  Address={hit.title}
                  status={hit.status}
                  link=""
                  priceQualifier={hit.price_qualifier && hit.price_qualifier}
                  priceDetails={hit.price && hit.price.toLocaleString()}
                  bedroom={hit.bedroom}
                  bathroom={hit.bathroom}
                  reception={hit.reception}
                  description={hit.description}
                  unkey={uuidv4()}
                  photoplans={photoplans}
                  //   videoid={item.video}
                />
                {hit.floorplan && JSON.stringify(hit.floorplan) !== "[]" ? (
                  <FloorPlanModal floorplanimg={hit.floorplan.url} />
                ) : (
                  ""
                )}
                <>
                  {hit.status === "Sold STC" ? (
                    <div className="flag">SOLD STC</div>
                  ) : (
                    ""
                  )}
                  {hit.status === "Let Agreed" ? (
                    <div className="flag">LET AGREED</div>
                  ) : (
                    ""
                  )}
                  {photoplans == true ? (
                    <a
                      href={hit.virtual_tour}
                      target="_blank"
                      className="photoplan"
                    >
                      <span className="play-btn">
                        <i className="icon-play"></i>
                      </span>
                    </a>
                  ) : (
                    <>
                      {hit.virtual_tour ? (
                        hit.virtual_tour.length > 0 ? (
                          <VideoPlay url={hit.virtual_tour} />
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </>
              </div>
            </div>
          ) : (
            <div className="result-tile">
              <Link
                onClick={() =>
                  mycookies.set(mysale, hit.objectID, {
                    path: "/",
                    maxAge: 300,
                  })
                }
                // to={`/${uriStr}${hit.slug}-${hit.objectID}`}
                propID={hit.objectID}
                className="map-wrapper"
              >
                <SearchList
                  images={hit.images}
                  floorplan={hit.floorplan}
                  virtual_tour={hit.virtual_tour}
                  Title={hit.display_address}
                  Address={hit.title}
                  status={hit.status}
                  link={`/${uriStr}${hit.slug}-${hit.objectID}`}
                  priceQualifier={hit.price_qualifier && hit.price_qualifier}
                  priceDetails={hit.price && hit.price.toLocaleString()}
                  bedroom={hit.bedroom}
                  bathroom={hit.bathroom}
                  reception={hit.reception}
                  description={hit.description}
                  unkey={uuidv4()}
                  photoplans={photoplans}
                  //   videoid={item.video}
                />
              </Link>
            </div>
          )}
        </div>
      )
  })*/}

      {hits?.length > 0 && hasMore && (
        <Button
                 className="btn--outline"
                 color="tsp"
                 id="mynextbut"
                 borderColor="blue"
                 textColor=""
                 displayAsLink={false}
                 onClick={refineNext}
                 disabled={!hasMore}
               >
          <Button.Text>Load more properties</Button.Text>
        </Button>
        // <button
        //   id="mynextbut"
        //   onClick={refineNext}
        //   disabled={!hasMore}
        //   className="more"
        // >
        //   Load more
        // </button>
      )}
    </>
  )
}
// const CustomInfiniteHits = connectInfiniteHits(InfiniteHits)
// Property results loop
// const CustomPagination = ({ currentRefinement, nbPages, refine, createURL, pagenumber }) => {
//   useEffect(() => {
//     if (parseInt(nbPages) <= parseInt(pagenumber)) {
//       $('.page-next').attr('disabled', true);
//     }
//     else {
//       $('.page-next').attr('disabled', false);
//     }

//     if (parseInt(pagenumber) == 1) {
//       $('.page-back').attr('disabled', true);
//     }
//     else {
//       $('.page-back').attr('disabled', false);
//     }
//   }, [pagenumber])


//   // Pagination select box
//   const paginationselect = () => {
//     var page_val = document.getElementById('pagination-select').value
//     navigate(createURL(page_val))
//     refine(page_val);

//     if (window) {
//       window.scroll({
//         top: -100,
//         behavior: 'smooth'
//       });
//     }
//   }
//   // Pagination select box

//   // Next Pagination Button
//   const nextpage = () => {
//     var next_page_number = parseInt(pagenumber) + 1
//     navigate(createURL(next_page_number))
//     refine(next_page_number);

//     if (window) {
//       window.scroll({
//         top: -100,
//         behavior: 'smooth'
//       });
//     }
//   }
//   // Next Pagination Button

//   // Previous Pagination Button
//   const prevpage = () => {
//     var prev_page_number = parseInt(pagenumber) - 1
//     navigate(createURL(prev_page_number))
//     refine(prev_page_number);

//     if (window) {
//       window.scroll({
//         top: -100,
//         behavior: 'smooth'
//       });
//     }
//   }
//   // Previous Pagination Button

//   return (
//     nbPages > 1 &&
//     <Row>
//       <Col md={2} className="col-2">
//         <button className="page-back" onClick={() => prevpage()}><i className="page-arrow-back"></i> 
//         <span className="d-none d-md-inline-block"> Back</span>
//         </button>
//       </Col>
//       <Col md={8} className="text-center col-8">
//         Page:<select id="pagination-select" onChange={() => paginationselect()}>
//           {new Array(nbPages).fill(null).map((_, index) => {
//             const page = index + 1;
//             return (
//               <option value={page}
//                 selected={pagenumber == page ? "selected" : ""}
//               >
//                 {page}
//               </option>
//             );
//           })}
//         </select>of {nbPages}
//       </Col>
//       <Col md={2} className="col-2 text-right">
//         <button className="page-next" onClick={() => nextpage()}>
//         <span className="d-none d-md-inline-block">Next</span>
//            <i className="page-arrow-next"></i></button>
//       </Col>
//     </Row>
//   )
// }

// const CustomPaginationRender = connectPagination(CustomPagination);
// Property results loop

// Searchbox
// const SearchBox = connectSearchBox(props => {
//   const { currentRefinement, refine } = props
//   // let value = typeof currentRefinement === 'string' ? currentRefinement
//   return (
//     <div className="filter-search">
//       <Form.Control
//         type="text"
//         className="location-field"
//         placeholder="Location"
//         id="formBasicEmail"
//         onChange={event =>
//           refine(
//             event.currentTarget.value
//               .replace(/ /g, "-")
//               .replace(/,/g, "-")
//               .replace(/'/g, "")
//               .toLowerCase()
//           )
//         }
//       // value={currentRefinement.replace(/-/g, ' ')}
//       />
//       <Link href="javascript:void(0)">
//         <i className="icon-search"></i>
//       </Link>
//     </div>
//   )
// })
// Searchbox

// Property Bedrooms
// const bedroomSelectBox = ({
//   currentRefinement,
//   min,
//   max,
//   precision,
//   refine,
// }) => {
//   let bedroomvalselect = ""
//   if (currentRefinement.max !== undefined) {
//     bedroomvalselect = 0
//   } else if (currentRefinement.min !== undefined) {
//     bedroomvalselect = currentRefinement.min
//   }

//   return (
//     <Select
//       name="beds"
//       options={bedOptions}
//       value={{
//         label: bedroomvalselect
//           ? bedOptions.filter(c => c.value == bedroomvalselect)[0].label
//           : "Bedrooms",
//         value: bedroomvalselect ? bedroomvalselect : "",
//       }}
//       placeholder="Bedrooms"
//       classNamePrefix={"select-opt bedroom-select-box"}
//       isSearchable={false}
//       onChange={e => {
//         if (e.value === "") {
//           refine(e.value, e.label)
//         } else if (e.value === "0") {
//           refine({
//             max: e.value,
//           })
//         } else {
//           refine({
//             min: e.value,
//           })
//         }
//       }}
//     />
//   )
// }

// const CustombedroomSelectbox = connectRange(bedroomSelectBox)
// // Property Bedrooms

// // Property type
// const buildingSelectbox = ({ items, currentRefinement, refine }) => (
//   <Select
//     name="building"
//     options={buildingOptions}
//     placeholder={
//       currentRefinement === null || undefined || ""
//         ? "Property Type"
//         : capitalize(currentRefinement).replace(/-/g, " ")
//     }
//     onChange={e => {
//       refine(e.value, e.label)
//     }}
//     isSearchable={false}
//     classNamePrefix={"select-opt bedroom-select-box"}

//   />
// )

// const CustombuildingSelectbox = connectMenu(buildingSelectbox)
// Property type

const customStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#B20838" : null,
      color: isFocused ? "#ffffff" : "#575757",
    }
  },
  control: styles => ({
    ...styles,
    backgroundColor: null,
    border: 0,
    paddingLeft: 0,
    outline: 0,
    boxShadow: "none",
    color: "#4c505b",
    fontSize: ".875rem",
    fontWeight: "300",
  }),
  valueContainer: styles => ({
    ...styles,
    fontSize: ".875rem",
    paddingLeft: 0,
    paddingRight: 0,
    lineHeight: "30px",
    fontWeight: "300",
    cursor: "pointer",
  }),
  dropdownIndicator: styles => ({
    ...styles,
    //  color: "#ffffff",
  }),
  indicatorsContainer: styles => ({
    ...styles,
    // color: '#ffffff',
    padding: 0,
    cursor: "pointer",
  }),
  indicatorSeparator: () => null,
  placeholder: defaultStyles => {
    return {
      ...defaultStyles,
      color: "#4c505b",
      marginLeft: 0,
    }
  },
}

// Dropdown react select styles

// const CustomSortBy = ({ items, refine, currentRefinement, auctionType }) => (
//   <div className="prices search-select-box">
//     <Select
//       options={items}
//       defaultValue={auctionType === "past" ? index_name + "_most_recent" : currentRefinement || ""}
//       classNamePrefix='sort-select'
//       className="field-select"
//       placeholder={auctionType === "past" ? "Most Recent" : "Highest Price"}
//       // classNamePrefix={"select-opt"}
//       isSearchable={false}
//       onChange={e => {
//         refine(e.value, e.label)
//       }}
//       styles={{
//         control: (styles, state) => ({
//           ...styles,
//           border: 'none',
//           outline: 'none',
//           background: "none",
//           maxWdith: '200px',
//           overflow: 'hidden',
//           top: '-1px',
//           borderColor: state.menuIsOpen && "transparent",
//           boxShadow: state.menuIsOpen && "none",
//           "&:hover": {
//             borderColor: state.menuIsOpen && "transparent",
//           },
//         }),
//         placeholder: styles => ({
//           ...styles,
//           color: '#026178',
//           fontSize: '1.4rem',
//           fontWeight: '600'
//         }),
//         valueContainer: styles => ({
//           ...styles,
//           padding: '3px 4px 0 2.5px',
//           fontSize: '1.4rem',
//           fontWeight: '600',
//           overflow: 'hidden',
//         }),
//         singleValue: styles => ({
//           ...styles,
//           color: '#026178',
//           paddingBottom: '1px'
//         }),
//         menu: styles => ({
//           ...styles,
//           width: '110%',
//           top: '75%',
//           borderRadius: '0 0 8px 8px'
//         })
//       }}
//     // /components={{ DropdownIndicator: () => <DownIndicator /> }}
//     />
//   </div>
// )

// const CustomSortByFilter = connectSortBy(CustomSortBy)

// Sort by

// No Results
const NoStats = ({ processingTimeMS, nbHits, ptype, auctions }) => {
  return (
    <>
      {nbHits === 0 && (
        <Row>
          <Col lg={12} className="no-properties-text mb-5">
            {/* <h5>
              Unfortunately, we do not currently have any properties that match
              your search criteria.
              <p>We have selected some of our showcase properties for you to browse below. Alternatively, you can search again in the bar above.</p>
            </h5> */}
            <NoResultList auctions={auctions} department={`residential`} status={(ptype === "lettings") ? "To Let" : "For Sale"} />
          </Col>
        </Row>
      )}
    </>
  )
}

// const CustomNoStats = connectStats(NoStats)
// const NoStats = ({ processingTimeMS, nbHits, ptype, map }) => {
//   return (
//     <>
//       {nbHits === 0 && (
//         <NoResultList map={map} department={`residential`} status={(ptype === "lettings") ? "To Let" : "For Sale"} />
//       )}
//     </>
//   )
// }
// No Results

// Results count
// const Stats = ({ processingTimeMS, nbHits }) => <>{nbHits}</>

// const CustomStats = connectStats(Stats)
// Results count

// Create URL
export const createURL = (props, state, location, refinementList) => {
  let myarea = state.menu
  console.log(state)
  const isDefaultRoute =
    !state.query &&
    !state.SortBy &&
    state.page === 1 &&
    state.menu &&
    state.range &&
    !state.range.price &&
    !state.range.bedroom
  // && (!state.configure.aroundRadius === 4828)

  if (isDefaultRoute) {
    return ""
  }

  var areaPath = defaultArea.slug ? `in-${defaultArea.slug}/` : ``
  var bedroomPath = ""
  var pricePath = ""
  var pagePath = ""
  var propertypath = ""
  var sortPath = ""
  var radiusPath = ""
  var includeSoldPath = ""
  var mustIncludePath = ""

  if (state.query) {
    if (state.query) {
      areaPath =
        "in-" + encodeURIComponent(decodeURIComponent(state.query)) + "/"
      areaPath = areaPath.replaceAll(" ", "-")
    }
  }

  const queryParameters = {}

  // Property path
  if (state.menu) {
    if (myarea["building"]) {
      propertypath = "type-" + myarea["building"] + "/"
    }
  }
  // Property path

  // radius path
  if (get(state, "configure.aroundRadius", false)) {
    if (state.configure.aroundRadius !== 4828) {
      let aroundRadius = meterToMiles(state.configure.aroundRadius) // meters to miles

      radiusPath = `radius-${aroundRadius}-miles/`
    }

    let tmparea = props.fullpathname.replace(props.locationname, "")
    tmparea = tmparea.split(/\/(.+)/)[0]

    if (tmparea.match(/in-/)) {
      areaPath = tmparea
      if (!areaPath.endsWith('/'))
        areaPath += '/'
    }
  }

  // Bedrooms & Price range path
  if (state.range) {
    // Bedrooms
    if (
      state.range.hasOwnProperty("bedroom") &&
      state.range.bedroom.max === 0
    ) {
      bedroomPath = "studio/" //queryParameters.price_max = state.range.price.max;
    }
    if (state.range.bedroom) {
      if (state.range.bedroom.min) {
        bedroomPath = state.range.bedroom.min + "-and-more-bedrooms/" //queryParameters.price_max = state.range.price.max;
      }
    }

    // Price
    if (state.range.price) {
      if (state.range.price.min && state.range.price.max) {
        pricePath =
          "between-" +
          state.range.price.min +
          "-and-" +
          state.range.price.max +
          "/" //queryParameters.price_min = state.range.price.min;
      } else if (state.range.price.max) {
        pricePath = "under-" + state.range.price.max + "/" //queryParameters.price_max = state.range.price.max;
      } else if (state.range.price.min) {
        pricePath = "over-" + state.range.price.min + "/" //queryParameters.price_max = state.range.price.max;
      }
    }
  }
  // Bedrooms & Price range path

  // Sort path
  if (state.sortBy) {
    if (state.sortBy === index_name + "_price_asc") {
      sortPath = "sortby-price-asc/"
    }
    if (state.sortBy === index_name + "_price_desc") {
      sortPath = ""
    }
    if (state.sortBy === index_name + "_most_recent") {
      sortPath = "sortby-most-recent/"
    }
    if (state.sortBy === index_name + "newest") {
      sortPath = "sortby-newest/"
    }
    if (state.sortBy === index_name + "featured") {
      sortPath = "sortby-featured/"
    }
  }
  // Sort path

  // Must include path
  if (refinementList && refinementList.length > 0) {
    mustIncludePath = `with-${refinementList.map(encodeURIComponent).join('-and-')}/`
  }
  // Must include path

  // Include sold path
  // if(!includeSold) {
  //   includeSoldPath="include-sold"
  // }
  // Include sold path


  // Page path
  if (state.page && state.page !== 1) {
    pagePath = `page-${state.page}/`
  }
  // Page path

  const queryString = qs.stringify(queryParameters, {
    addQueryPrefix: true,
    arrayFormat: "repeat",
  })

  // Keep the auction month (from a Current auctions card) when other filters change
  const monthPath = getAuctionMonthSegment(props?.fullpathname)

  let myUrl = `${areaPath}${monthPath}${propertypath}${bedroomPath}${pricePath}${radiusPath}${mustIncludePath}${includeSoldPath}${queryString}${pagePath}${sortPath}`

  // if ("/" === myUrl.substr(myUrl.length - 1))
  //   myUrl = myUrl.substr(0, myUrl.length - 1)

  return `${location}${myUrl}`
}
// Create URL

// URL to searchstate
const searchStateToUrl = (props, searchState, location) =>
  searchState ? `${createURL(props, searchState, location)}` : ""

const urlToSearchState = (location, areaList = []) => {
  if (location) {
    var query = ""
    let pathUri_main = ""
    let a1, a2, a3, a4, a5

    if (location?.pathname) {
      a1 = location.pathname.indexOf("/property/for-sale") > -1
      a2 = location.pathname.indexOf("/property/to-rent") > -1
      a3 = location.pathname.indexOf("/property-auctions/for-sale") > -1
      a4 = location.pathname.indexOf("/property-auctions/previous-auction-results") > -1
      a5 = location.pathname.indexOf("/new-homes") > -1

      if (a1 == true) {
        pathUri_main = location.pathname.split("/property/for-sale")
      } else if (a2 == true) {
        pathUri_main = location.pathname.split("/property-to-rent")
      } else if (a3 == true) {
        pathUri_main = location.pathname.split("/property-auctions/for-sale")
      } else if (a4 == true) {
        pathUri_main = location.pathname.split("/property-auctions/previous-auction-results")
      } else if (a5 == true) {
        pathUri_main = location.pathname.split("/new-homes")
      } else {
        pathUri_main = location.pathname.split(location)
      }
    }

    var areaVal = ""
    var bedVal = 10
    var minpriceVal = ""
    var maxpriceVal = ""
    var pageVal = ""
    var propertyval = ""
    var sortVal = ""
    var sortVal_filt = ""
    var radiusVal = ""
    // var includeSold
    var mustIncludeVal = ""

    if (pathUri_main[1]) {
      // following could be regexp
      let pathUri = pathUri_main[1].split("/")

      //lets loop
      for (let vi = 1; vi <= pathUri.length; vi++) {
        // check for area
        if (typeof pathUri[vi] === "undefined") {
          continue
        }

        // Property type
        if (pathUri[vi].indexOf("type-") >= 0) {
          propertyval = pathUri[vi].replace("type-", "")
        }

        // // Include sold
        // if (pathUri[vi].indexOf("include-sold") >= 0) {
        //   includeSold = "Sold Subject To Contract"
        // }

        // Radius
        if (pathUri[vi].indexOf("radius-") >= 0) {
          radiusVal = pathUri[vi].replace("radius-", "").replace("-miles")
        }

        // Area
        if (pathUri[vi].indexOf("in-") >= 0) {
          areaVal = pathUri[vi].replace("in-", "")
        }

        // Price
        if (
          pathUri[vi].indexOf("between-") >= 0 ||
          pathUri[vi].indexOf("over-") >= 0 ||
          pathUri[vi].indexOf("under-") >= 0
        ) {
          let priceFilt1 = pathUri[vi].split("over-")
          if (priceFilt1[1]) {
            minpriceVal = priceFilt1[1]
          }
          let priceFilt2 = pathUri[vi].split("under-")
          if (priceFilt2[1]) {
            maxpriceVal = priceFilt2[1]
          }
          let priceFilt3 = pathUri[vi].split("between-")
          if (priceFilt3[1]) {
            let priceFilt4 = priceFilt3[1].split("-and-")
            minpriceVal = priceFilt4[0]
            maxpriceVal = priceFilt4[1]
          }
        }

        // Bedrooms
        if (pathUri[vi].indexOf("-and-more-") >= 0) {
          bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
        }

        if (pathUri[vi].indexOf("studio") >= 0) {
          // its studio bedroom
          bedVal = 0
        }

        // Sort by
        if (pathUri[vi].indexOf("sortby-") >= 0) {
          sortVal_filt = pathUri[vi].replace("sortby-", "")

          if (sortVal_filt === "price-asc") {
            sortVal = index_name + "_price_asc"
          }

          if (sortVal_filt === "price-desc") {
            sortVal = index_name
          }

          if (sortVal_filt === "most-recent") {
            sortVal = index_name + "_most_recent"
          }

          if (sortVal_filt === "newest") {
            sortVal = index_name + "newest"
          }
          if (sortVal_filt === "featured") {
            sortVal = index_name + "featured"
          }
        }

        // Must Include
        if (pathUri[vi].indexOf("with-") >= 0) {
          var mustIncludeArrfilt = pathUri[vi].replace("with-", "")
          mustIncludeVal = mustIncludeArrfilt.split("-and-")
        }

        // Page
        if (pathUri[vi].indexOf("page") >= 0) {
          pageVal = pathUri[vi].replace("page-", "")
        }
      }
    }
  }

  // Property type
  if (propertyval) {
    query += `&menu[building]=` + propertyval
  }

  // if (mustIncludeVal) {
  //   for(let v=0; v <= mustIncludeVal.length; v++){
  //       if (typeof mustIncludeVal[v] !== "undefined") {
  //           query += `&refinementList[must_include]=` + mustIncludeVal[v]
  //       }
  //   }
  // }
  // Property type
  // if (includeSold) {
  //   query += `&refinementList[status]=` + includeSold 
  //   query += `&refinementList[status]=` + 'For Sale'
  // }

  // radius
  // if (areaVal && areaList.length) {
  //     let selectedArea = isAreaMatch(areaList, areaVal);
  //     let aroundLatLngTmp;
  //     let refineRadius = milesToMeter(radiusVal || 3);
  //     if (!isEmpty(selectedArea)) {
  //         aroundLatLngTmp = selectedArea.latlan;
  //     }
  //
  //     console.log("dddd fff 111", aroundLatLngTmp, refineRadius)
  //     if (aroundLatLngTmp && refineRadius) {
  //         console.log("dddd fff 222", aroundLatLngTmp, refineRadius)
  //         query += `&aroundRadius=${refineRadius}` // + propertyval
  //         query += `&aroundLatLng=${aroundLatLngTmp}` // + propertyval
  //     }
  // }

  // Area
  if (areaVal) {
    areaVal = areaVal.toLowerCase()
    if (
      (areaVal.replaceAll(' ', '-')) === defaultArea.slug ||
      (areaVal && areaList.length && !isEmpty(isAreaMatch(areaList, areaVal)))
    ) {
      query += `&query=`
    } else {
      query += `&query=` + areaVal
    }
  }

  // Price
  if (minpriceVal) {
    query += `&range[price][min]=` + minpriceVal
  }

  if (maxpriceVal) {
    query += `&range[price][max]=` + maxpriceVal
  }

  // Bedrooms
  if (bedVal == 0) {
    query += `&range[bedroom][min]=` + 0
  } else if (bedVal < 10) {
    query += `&range[bedroom][min]=` + bedVal
  }

  // Must Include
  if (mustIncludeVal) {
    for (let v = 0; v <= mustIncludeVal.length; v++) {
      if (typeof mustIncludeVal[v] !== "undefined") {
        query += `&refinementList[must_include]=` + mustIncludeVal[v]
      }
    }
  }

  // Page
  if (pageVal) {
    query += `&page=${pageVal}`
  }

  // Sort by
  if (sortVal) {
    query += `&sortBy=` + sortVal
  }

  return qs.parse(query)
}
// URL to searchstate

const styles = {
  control: styles => ({
    ...styles,
    backgroundColor: "#b208381c",
    border: 0,
    outline: 0,
    boxShadow: "none",
    fontSize: "14px",
    color: "#263140",
    minHeight: "3rem",
    paddingLeft: "1rem",
    marginBottom: "1rem",
  }),
  placeholder: defaultStyles => {
    return {
      ...defaultStyles,
      color: "#263140",
    }
  },
}

// const minpriceSelectbox = ({
//   currentRefinement,
//   min,
//   max,
//   precision,
//   refine,
// }) => {
//   let minPriceRange = priceminRange
//   if (currentRefinement.max !== undefined && currentRefinement.max != "0") {
//     minPriceRange = priceminRange.filter(
//       x => parseInt(x.value) < parseInt(currentRefinement.max)
//     )
//   }
//   return (
//     <Select
//       name="minprice"
//       options={minPriceRange}
//       isSearchable={false}
//       classNamePrefix={"price-select-box"}
//       defaultValue={currentRefinement.min || "0"}
//       value={{
//         label: currentRefinement.min
//           ? get(
//             minPriceRange.filter(c => c.value == currentRefinement.min),
//             "0.label"
//           )
//           : "Min Price",
//         value: currentRefinement.min ? currentRefinement.min : "",
//       }}
//       placeholder="Minimum Price"
//       onChange={e => {
//         minpriceval = e.value
//         if (e.value === "0") {
//           if (maxpriceval) {
//             refine({
//               max: maxpriceval,
//             })
//           } else refine(e.value, e.label)
//         } else {
//           refine({
//             min: e.value,
//             max: maxpriceval,
//           })
//         }
//       }}
//       //components={{ DropdownIndicator:() => <SelectArrow />, IndicatorSeparator:() => null }}
//       styles={styles}
//     />
//   )
// }

// const CustomminpriceSelectbox = connectRange(minpriceSelectbox)
// // Min Price

// // Max Price

// const maxpriceSelectbox = ({
//   currentRefinement,
//   min,
//   max,
//   precision,
//   refine,
// }) => {
//   let maxPriceRange = pricemaxRange
//   let maxpricedisable = ""
//   if (currentRefinement.min !== undefined) {
//     maxPriceRange = pricemaxRange.filter(
//       x => x.value == "0" || parseInt(x.value) > parseInt(currentRefinement.min)
//     )
//   }
//   if (currentRefinement.min == "30000000") {
//     maxpricedisable = "disabled"
//   }
//   return (
//     <Select
//       name="maxprice"
//       options={maxPriceRange}
//       isSearchable={false}
//       classNamePrefix={"price-select-box"}
//       defaultValue={currentRefinement.max || "0"}
//       value={{
//         label: currentRefinement.max
//           ? get(
//             maxPriceRange.filter(c => c.value == currentRefinement.max),
//             "0.label"
//           )
//           : "Max Price",
//         value: currentRefinement.max ? currentRefinement.max : "",
//       }}
//       placeholder="Maximum Price"
//       onChange={e => {
//         maxpriceval = e.value
//         if (e.value === "0") {
//           if (minpriceval) {
//             refine({
//               min: minpriceval,
//             })
//           } else refine(e.value, e.label)
//         } else {
//           refine({
//             min: minpriceval,
//             max: e.value,
//           })
//         }
//       }}
//       //components={{ DropdownIndicator:() => <SelectArrow />, IndicatorSeparator:() => null }}
//       styles={styles}
//     />
//   )
// }

// const CustommaxpriceSelectbox = connectRange(maxpriceSelectbox)
// // Max Price

// // Property Rentals Min Price
// const minpriceSelectBoxRentals = ({
//   currentRefinement,
//   min,
//   max,
//   precision,
//   refine,
// }) => {
//   let minPriceRangeRentals = priceminRangeRentals
//   if (currentRefinement.max !== undefined && currentRefinement.max != "0") {
//     minPriceRangeRentals = priceminRangeRentals.filter(
//       x => parseInt(x.value) < parseInt(currentRefinement.max)
//     )
//   }

//   return (
//     <div className="select-group">
//       <Select
//         name="price"
//         options={minPriceRangeRentals}
//         defaultValue={currentRefinement.min || "0"}
//         placeholder="Minimum Price"
//         classNamePrefix={"select-opt"}
//         isSearchable={false}
//         onChange={e => {
//           minpricevalrentals = e.value
//           if (e.value === "0") {
//             if (maxpricevalrentals !== "0") {
//               refine({
//                 max: maxpricevalrentals,
//               })
//             } else refine(e.value, e.label)
//           } else {
//             if (maxpricevalrentals == "0") {
//               refine({
//                 min: e.value,
//                 // max: maxpricevalrentals,
//               })
//             } else {
//               refine({
//                 min: e.value,
//                 max: maxpricevalrentals,
//               })
//             }
//           }
//         }}
//         styles={styles}
//       />
//     </div>
//   )
// }

// const CustomminpriceSelectboxRentals = connectRange(minpriceSelectBoxRentals)
// // Property Rentals Min Price

// // Property Rentals Max Price
// const maxpriceSelectBoxRentals = ({
//   currentRefinement,
//   min,
//   max,
//   precision,
//   refine,
// }) => {
//   let maxPriceRangeRentals = pricemaxRangeRentals
//   let maxpricedisablerentals = ""
//   if (currentRefinement.min !== undefined) {
//     maxPriceRangeRentals = pricemaxRangeRentals.filter(
//       x => x.value == "0" || parseInt(x.value) > parseInt(currentRefinement.min)
//     )
//   }
//   if (currentRefinement.min == "10000000") {
//     maxpricedisablerentals = "disabled"
//   }

//   return (
//     <div className="select-group">
//       <Select
//         name="price"
//         options={maxPriceRangeRentals}
//         defaultValue={currentRefinement.max || "0"}
//         placeholder="Maximum Price"
//         classNamePrefix={"select-opt"}
//         isSearchable={false}
//         onChange={e => {
//           maxpricevalrentals = e.value
//           if (e.value === "0") {
//             if (minpricevalrentals) {
//               refine({
//                 min: minpricevalrentals,
//               })
//             } else refine(e.value, e.label)
//           } else {
//             refine({
//               min: minpricevalrentals,
//               max: e.value,
//             })
//           }
//         }}
//         styles={styles}
//       />
//     </div>
//   )
// }

// const CustommaxpriceSelectboxRentals = connectRange(maxpriceSelectBoxRentals)
// // Property Rentals Max Price

// // Include sold
// const ToggletttRefinementSold = ({
//   currentRefinement,
//   label,
//   count,
//   refine,
//   createURL,
// }) => {
//   return (
//     <a
//       href={"#"}
//       onClick={event => {
//         event.preventDefault()
//         includeSold = !includeSold
//         refine(!currentRefinement)
//       }}
//     >
//       <div className="btn-field">
//         <label class="switch">
//           <input
//             type="checkbox"
//             id="toggle-button"
//             checked={includeSold ? "checked" : ""}
//           />
//           <span class="slider round"></span>
//         </label>
//         <span className="text">Include Sold</span>
//       </div>
//     </a>
//   )
// }

// const CustomToggleRefinementSold = connectToggleRefinement(
//   ToggletttRefinementSold
// )
// // Include sold

// // Include Let
// const ToggletttRefinementLet = ({
//   currentRefinement,
//   label,
//   count,
//   refine,
//   createURL,
// }) => {
//   return (
//     <a
//       href={"#"}
//       onClick={event => {
//         event.preventDefault()
//         includeLet = !includeLet
//         refine(!currentRefinement)
//       }}
//     >
//       <div className="btn-field">
//         <label class="switch">
//           <input
//             type="checkbox"
//             id="toggle-button"
//             checked={includeLet ? "checked" : ""}
//           />
//           <span class="slider round"></span>
//         </label>
//         <span className="text">Include Let</span>
//       </div>
//     </a>
//   )
// }

// const CustomToggleRefinementLet = connectToggleRefinement(
//   ToggletttRefinementLet
// )

const main_page = typeof window !== "undefined" ? window.location : ""
// Include Let

class AuctionPropertySearchSales extends React.Component {
  constructor(props) {
    super(props)
  }

  //
  state = {
    searchState: urlToSearchState(
      typeof window !== "undefined" ? window.location : ""
    ),
    userObjects: [],
    areaList: [],
    viewType: 'list',
    includes: false,
    showForm: false
  }

  openform = (val) => {
    this.setState({ showForm: val })

  }

  onViewChange = (type) => {
    this.setState({ viewType: type })
  }

  componentDidUpdate(prevProps, prevState) {

    if (!prevState.areaList.length && this.props.areaList.length) {
      this.setState({ areaList: this.props.areaList })
    }

    if (
      prevProps.fullpathname !== this.props.fullpathname ||
      prevState.areaList.length !== this.state.areaList.length
    ) {
      this.setState({
        searchState: urlToSearchState(
          this.props.fullpathone,
          this.state.areaList
        ),
      })
    }
  }

  onSearchStateChange = searchState => {
    clearTimeout(this.debouncedSetState)
    this.debouncedSetState = setTimeout(() => {
      navigate(
        searchStateToUrl(this.props, searchState, this.props.locationname),
        searchState
      )
    }, updateAfter)
    this.setState({ searchState })
  }

  componentDidMount() {
    // getting area list
    if (!this.state.areaList.length && this.props.areaList.length) {
      this.setState({ areaList: this.props.areaList })
    }

    // $(document).mouseup(function (e) {
    //   var container = $(".price-filter-dropdown")

    //   // if the target of the click isn't the container nor a descendant of the container
    //   if (!container.is(e.target) && container.has(e.target).length === 0) {
    //     $(".price-filter-dropdown").removeClass("active")
    //   }
    // })

    // if ((window.location.href).indexOf('property\/' + this.props.ptypetag)) {

    //   // Infinite properties scroll
    //   $(window).scroll(function () {

    //     if ( $("#mynextbut").length ) {
    //       var top_of_element = $("#mynextbut").offset().top;
    //       var bottom_of_element = $("#mynextbut").offset().top + $("#mynextbut").outerHeight();
    //       var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    //       var top_of_screen = $(window).scrollTop();

    //       if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
    //         $("#mynextbut").trigger( "click" );
    //          //window.scrollTo({ top: top_of_element-100, behavior: 'smooth' });
    //           // the element is visible, do something
    //       }
    //     }


    //   });
    //   // Infinite properties scroll
    // }

    // window.addEventListener("scroll", this.handleScroll, true)

    // load on top
    $(document).ready(function () {
      $("html, body").scrollTop(0)
    })
    // load on top

    //
    $(".property_sortby_asc").click(function () {
      $(".property_sortby_asc").addClass("active")
      $(".property_sortby_desc").removeClass("active")
    })

    $(".property_sortby_desc").click(function () {
      $(".property_sortby_desc").addClass("active")
      $(".property_sortby_asc").removeClass("active")
    })
    //

    // iPhone input fields zoom fix
    $("head").append(
      '<meta name="viewport" content="width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=1.0, user-scalable=0">'
    )
    // iPhone input fields zoom fix
  }

  // Sales & Rent

  onClickBuy = e => {
    if (this.props.locationname != "/property/for-sale/") {
      navigate(`/property/for-sale/in-${defaultArea.slug}/`)
    }
  }

  onClickRent = e => {
    if (this.props.locationname != "/property-to-rent/") {
      navigate(`/property-to-rent/in-${defaultArea.slug}/`)
    }
  }
  // Sales & Rent

  render() {
    const arrowClick = () => {
      arrow = true
    }
    const handlerClick = () => { }

    //
    const clickHandle = e => {
      const li = e.target.closest("li")
      li.closest("ul")
        .querySelectorAll("li")
        .forEach(item => {
          if (item !== li) {
            item.classList.remove("active")
          }
        })
      e.target.closest("li").classList.toggle("active")
    }

    const capitalize = s => {
      if (typeof s !== "string") return ""
      return s.charAt(0).toUpperCase() + s.slice(1)
    }

    const searchParams = parseSearchUrl(
      this.props.ptype,
      this.props.fullpathname,
      this.props?.auctionType
    )

    const saveSearchParams = savedSearchParams(searchParams)

    const h1 = propertyH1({ ...searchParams, ptypetag: this?.props?.ptypetag }, this?.props?.auctionType)

    const auctionMonth = getAuctionMonthFromPath(this.props?.fullpathname)

    const areaName = searchParams.areas

    const pType = searchParams.pType

    let propertyType = ""
    if (searchParams.type == "") {
      propertyType = "property "
    } else {
      propertyType = searchParams.type
    }

    const actionStr = ACTION_TYPES[pType]
    const actionDescStr = ACTION_DESC_TYPES[pType]

    var description = `Looking for ${capitalize(
      this.props.pcategorytype
    )} ${capitalize(propertyType)}${actionStr}${searchParams.areas
      }. Strakers property experts are here to help with all your property needs.`
    if (searchParams.type) {
      description = `Check out the ${capitalize(propertyType)}${actionStr}${searchParams.areas
        } with Strakers, expert real estate agents in ${searchParams.areas}.`
    }
    if (searchParams.price.min || searchParams.price.max) {
      description = `Discover the wide range of ${capitalize(
        this.props.pcategorytype
      )} ${capitalize(propertyType)}${actionStr}${searchParams.areas
        } with Strakers. Book an appointment with one of our property expert today to find the perfect property ${actionDescStr} anywhere in ${searchParams.areas
        }.`
    }
    if (searchParams.bedrooms) {
      description = `Browse ${searchParams.bedrooms} bedroom ${capitalize(
        this.props.pcategorytype
      )} ${capitalize(propertyType)}${actionStr}${searchParams.areas
        }. Check here for the finest collection of ${searchParams.areas
        } property.`
    }
    if (
      (searchParams.price.min || searchParams.price.max) &&
      searchParams.type
    ) {
      description = `Find the latest ${capitalize(propertyType)}${actionStr}${searchParams.areas
        } here. Strakers offers a wide range of ${capitalize(
          propertyType
        )}${actionStr}${searchParams.areas}.`
    }
    if (
      (searchParams.price.min || searchParams.price.max) &&
      searchParams.bedrooms
    ) {
      description = `Find ${searchParams.bedrooms} bedroom ${capitalize(
        this.props.pcategorytype
      )} ${capitalize(propertyType)}${actionStr}${searchParams.areas
        } with Strakers,  Contact us for more details about property in ${searchParams.areas
        }.`
    }
    if (searchParams.type && searchParams.bedrooms) {
      description = `Discover the best ${searchParams.bedrooms
        } bedroom ${capitalize(propertyType)}${actionStr}${searchParams.areas
        }, Contact Strakers leading estate and letting agents in ${searchParams.areas
        }.`
    }
    if (
      (searchParams.price.min || searchParams.price.max) &&
      searchParams.type &&
      searchParams.bedrooms
    ) {
      description = `Check out ${searchParams.bedrooms} bedroom ${capitalize(
        propertyType
      )}${actionStr}${searchParams.areas} ${getPriceStr(
        searchParams.price
      )} with Strakers, our experts help you find the perfect ${capitalize(
        propertyType
      )} in ${searchParams.areas}.`
    }

    const isPageLoadBg = typeof this.props.fullpathname === "undefined"

    // // Geo toggle tablet & mobile
    // const geoPinClick = e => {
    //   $(".property_map_pin").removeClass("active")
    //   $(".property_map_list").addClass("active")

    //   $(".property_list_results").addClass("d-none")
    //   $(".right-side").removeClass("mobile-none")
    // }

    // const geoToggleClick = e => {
    //   $(".property_map_list").removeClass("active")
    //   $(".property_map_pin").addClass("active")

    //   $(".property_list_results").removeClass("d-none")
    //   $(".right-side").addClass("mobile-none")
    // }
    // // Geo toggle tablet & mobile

    // const filterRefine = e => {
    //   $(".filter-section").removeClass("refine")
    //   $("#filter-one").hide()
    //   $("#filter-two").show()
    // }
    // const filterRefineone = e => {
    //   $(".filter-section").addClass("refine")
    //   $("#filter-one").show()
    //   $("#filter-two").hide()
    // }


    if (typeof window !== "undefined" && window) {

      document.addEventListener('DOMContentLoaded', function () {
        var elem = document.getElementById("eig-online");
        elem.remove();
      });
      var s = document?.getElementById("eig-online-launcher-container")
      var t = document?.getElementById("eig-online-widget-container")

      if (s) {
        s.style.display = 'none'
      }
      if (t) {
        t.style.display = 'none'
      }
    }

    let mystatus = ''
    if (this?.props?.pstatustype) {
      if (Array.isArray(this?.props?.pstatustype)) {
        mystatus = ' AND (status:"' + (this?.props?.pstatustype).join('" OR status:"') + '")'
      } else {
        mystatus = ' AND (status:"' + (this?.props?.pstatustype) + '")'
      }
    }
    let auctionQuery= "";
    if(this.props.auctionId){
      auctionQuery = `AND client_id: ${this.props.auctionId}`
    }
        const sortby_options = [
          { value: 'most-recent', label: 'Most Recent' },
          { value: '', label: 'Highest Price' },
          { value: 'price-asc', label: 'Lowest Price' }
        ];
        let sortby_key;
        if (this.props?.page_url_data?.sortVal === "") {
          sortby_key = 1;
        } else if (this.props?.page_url_data?.sortVal === process.env.GATSBY_ALGOLIA_INDEX_NAME + "_most_recent") {
          sortby_key = 0;
        } else if (this.props?.page_url_data?.sortVal === process.env.GATSBY_ALGOLIA_INDEX_NAME + "_price_asc") {
          sortby_key = 2;
        }
        
        const changesortby = event => {
          //get sortby value
          let sortbyUrl = '';
          if (event?.value) {
            sortbyUrl = 'sortby-' + event.value + '/'
          }
          //get current url
          const urlwithoutsort_filt = (this.props?.fullpathname).split("page-");
          const urlwithoutsort = urlwithoutsort_filt[0].split("sortby-");
          // concat url and navigate
          navigate(urlwithoutsort[0] + sortbyUrl)
        }
    return (
      <Layout
        resultlabel={searchParams.pType}
        searchtype={searchParams.pType}
        searchBedroomfield={searchParams.bedrooms}
        searchPtype={searchParams.type}
        Searcharea={searchParams}
        type={"auction"}
      >
        <section>
          {!isPageLoadBg && (
            <SeoResults
              title={h1}
              searchParams={searchParams}
              description={description}
              location={this.props.fullpathname}
              pcategorytype={this.props.pcategorytype}
              ptypetag={this.props?.ptypetag}
            />
          )}

          {/* <InstantSearch
            indexName={index_name}
            searchClient={searchClient}
            searchState={this.state.searchState}
            onSearchStateChange={this.onSearchStateChange}
            createURL={createURL}
            routing="true"
          > */}
            {/* {this.props.auctionType === "future" &&
           <div className="filter-form">
           <Container>
           <FilterForm {...this.props}
            searchParams={searchParams}
            tag={this.props.ptypetag}
            searchType={this.props.ptype}
            resultSetState={this.setState}
            pcategorytype={this.props.pcategorytype}
            areaList={this.state.areaList} />
          </Container>
          </div>} */}
            <div className="d-none">
              {/* <RefinementList
              attribute="search_type"
              defaultRefinement={[this.props.ptype]}
            />
            <RefinementList
              attribute="department"
              defaultRefinement={[this.props.pcategorytype]}
            />
            {this?.props?.auctionType &&
            <RefinementList
            attribute="auctionType"
            defaultRefinement={this.props.auctionType}
          />
            }
            {this.props?.pstatustype && (
              <RefinementList
                attribute="status"
                defaultRefinement={[this.props.pstatustype]}
              />
            )} */}
              {/* <RefinementList
                attribute="status"
                defaultRefinement={["For Sale", "Sold"]}
              /> */}
              {/* <RefinementList
                attribute="status"
                defaultRefinement={[
                  "For Sale",
                  "To Let",
                ]}
              /> */}
            </div>
            {/* <Configure
              filters={`search_type:${this.props.ptype} AND auctionType:${this.props.auctionType} AND department:${this.props.pcategorytype}${mystatus} ${auctionQuery}`}
              hitsPerPage={16} /> */}
            <div className="">
              <div className="">
                <div className="">
                  <Container>
                    <>
                      <Form className="form-info d-none">
                        <Form.Group controlId="buy_rent" className="buy_rent">
                          <div className="radio-boxes">
                            <a
                              href={
                                this.props.locationname != "/property/for-sale/"
                                  ? "javascript:void(0)"
                                  : `/property/for-sale/in-${defaultArea.slug}/`
                              }
                              className={`property_filter_btn ${this.props.ptype == "sales" && "active"
                                }`}
                              onClick={this.onClickBuy}
                            >
                              Buy
                            </a>
                            <a
                              href={
                                this.props.locationname != "/property/to-rent/"
                                  ? "javascript:void(0)"
                                  : `/property-to-rent/in-${defaultArea.slug}/`
                              }
                              className={`property_filter_btn ${this.props.ptype == "lettings" && "active"
                                } `}
                              onClick={this.onClickRent}
                            >
                              Rent
                            </a>
                          </div>
                        </Form.Group>
                        <Form.Group controlId="formBasicEmail">
                          {/* <SearchBox /> */}
                        </Form.Group>
                        {/* <Form.Group>
                          <div className="filter-select-field">
                            <ul className="price-filter-list">
                              <li className="price-filter-dropdown">
                                <button type="button" onClick={clickHandle}>
                                  Price Range
                                </button>
                                <div className="filter-dropdown">
                                  <div className="select">
                                    {this.props.ptype == "sales" ? (
                                      <CustomminpriceSelectbox attribute="price" />
                                    ) : (
                                      <CustomminpriceSelectboxRentals attribute="price" />
                                    )}
                                  </div>
                                  <div className="select">
                                    {this.props.ptype == "sales" ? (
                                      <CustommaxpriceSelectbox attribute="price" />
                                    ) : (
                                      <CustommaxpriceSelectboxRentals attribute="price" />
                                    )}
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <i className="icon-menu-slider"></i>
                        </Form.Group>

                        <Form.Group className="bed-room">
                          <CustombedroomSelectbox attribute="bedroom" />
                          <i className="icon-menu-slider"></i>
                        </Form.Group>

                        <Form.Group className="building">
                          <CustombuildingSelectbox attribute="building" />
                          <i className="icon-menu-slider"></i>
                        </Form.Group> */}
                      </Form>
                    </>
                  </Container>
                </div>
                <Container className="search-results-properties">
                  <div className="search-results-properties__head">
                    <h1>{h1.replace(/-/g, " ")}{" "}
                      {/* <span>
                        (
                        <span className="bold">
                          <CustomStats />
                        </span>
                        )
                      </span> */}
                    </h1>
                    {this.props.auctionType === "future" &&
                      <p>
                        {/* Discover a wide range of {makeLowerCaseExceptArea(h1.replace(/-/g, " "))} with Strakers Estate Agents. To filter these results, use our filter above, or for more information please <Link to="/about/our-branches/">contact us</Link>. */}
                        Discover the Lots in our upcoming auction. <Link to="/about/our-branches/">Get in touch</Link> to book a viewing.
                      </p>
                    }
                    {auctionMonth &&
                      <p className="auction-month-filter">
                        Showing {moment(auctionMonth, "YYYY-MM").format("MMMM YYYY")} auctions.{" "}
                        <Link to="/property-auctions/for-sale/">View all auctions</Link>
                      </p>
                    }
                    <div className="scroll-fix" ref={myRef}></div>
                    <Row className="g-0 align-items-center justify-content-between">
                      <Col xs="auto">
                        <Row className="g-0 align-items-center">
                          <Col xs="auto" className="search-results-properties__breadcrumb">
                            <span>{this.props?.total} results</span>
                          </Col>
                          {/* {this.props.auctionType === "future" && */}
                          <>
                            <Col xs="auto" className="delimiter">
                              /
                            </Col>
                            <Col className="search-results-properties__sort d-flex align-items-center">
                              <span>Sort by</span>
                              <div className="search-results-properties__sort-select d-flex">
                              <div className="prices search-select-box">
    <Select
                                options={sortby_options}
                                defaultValue={sortby_options[sortby_key]}
                                value={sortby_options.value}
      classNamePrefix='sort-select'
      className="field-select"
      placeholder={sortby_options[sortby_key]?.label}
      // classNamePrefix={"select-opt"}
      isSearchable={false}
      onChange={changesortby}
      styles={{
        control: (styles, state) => ({
          ...styles,
          border: 'none',
          outline: 'none',
          background: "none",
          maxWdith: '200px',
          overflow: 'hidden',
          top: '-1px',
          borderColor: state.menuIsOpen && "transparent",
          boxShadow: state.menuIsOpen && "none",
          "&:hover": {
            borderColor: state.menuIsOpen && "transparent",
          },
        }),
        placeholder: styles => ({
          ...styles,
          color: '#026178',
          fontSize: '1.4rem',
          fontWeight: '600'
        }),
        valueContainer: styles => ({
          ...styles,
          padding: '3px 4px 0 2.5px',
          fontSize: '1.4rem',
          fontWeight: '600',
          overflow: 'hidden',
        }),
        singleValue: styles => ({
          ...styles,
          color: '#026178',
          paddingBottom: '1px'
        }),
        menu: styles => ({
          ...styles,
          width: '110%',
          top: '75%',
          borderRadius: '0 0 8px 8px'
        })
      }}
    // /components={{ DropdownIndicator: () => <DownIndicator /> }}
    />
  </div>
                                {/* <CustomSortByFilter
                                  defaultRefinement={index_name}
                                  // className="search-sory-by"
                                  auctionType={this.props.auctionType}
                                  items={[
                                    {
                                      value: index_name + "_most_recent",
                                      label: "Most Recent",
                                    },
                                    {
                                      value: index_name,
                                      label: "Highest Price",
                                    },
                                    {
                                      value: index_name + "_price_asc",
                                      label: "Lowest Price",
                                    },
                                  ]}
                                /> */}
                                {/* <FieldSelect
                    options={[
                      {
                        value: index_name + "_price_desc",
                        label: "Highest Price",
                      },
                      {
                        value: index_name + "_price_asc",
                        label: "Lowest Price",
                      },
                    ]}
                    classNamePrefix='sort-select'
                    defaultRefinement={index_name}
                    placeholder="Highest Price"
                    onChange={e => {
                      refine(e.value, e.label)
                    }}
                    styles={{
                      control: (styles, state) => ({
                        ...styles,
                        border: 'none',
                        outline: 'none',
                        background: "none",
                        maxWdith: '200px',
                        overflow: 'hidden',
                        top: '-1px',
                        borderColor: state.menuIsOpen && "transparent",
                        boxShadow: state.menuIsOpen && "none",
                        "&:hover": {
                          borderColor: state.menuIsOpen && "transparent",
                        },
                      }),
                      placeholder: styles => ({
                        ...styles,
                        color: '#026178',
                        fontSize: '1.4rem',
                        fontWeight: '600'
                      }),
                      valueContainer: styles => ({
                        ...styles,
                        padding: '3px 4px 0 2.5px',
                        fontSize: '1.4rem',
                        fontWeight: '600',
                        overflow: 'hidden',
                      }),
                      singleValue: styles => ({
                        ...styles,
                        color: '#026178',
                        paddingBottom: '1px'
                      }),
                      menu: styles => ({
                        ...styles,
                        width: '110%',
                        top: '75%',
                        borderRadius: '0 0 8px 8px'
                      })
                    }}
                  /> */}
                              </div>
                            </Col>
                          </>
                          {/* } */}
                        </Row>
                      </Col>

                      <Col xs="12" md="auto">
                        <Row className="search-results-properties__links g-0 position-relative">


                          <Col xs="auto" className="d-none d-lg-flex ms-lg-4_6">
                            {/* <LinkIcon  text="Subscribe to Catalogue" /> */}
                            <a onClick={() => this.openform(true)}
                              href="javascript:void(0)"
                              // customLink={customLink}
                              class="link-icon blue-link-hover d-flex align-items-center"
                            // label={""}
                            // alias={href}
                            // Link_Type={Link_Type}
                            >
                              <div
                                className={`link-icon__text fw-bolder fz14 position-relative order-0`}
                              >
                                Subscribe to Catalogue
                              </div>
                              <i className={classNames(`icon icon--arrow-up-right`)}></i>
                            </a>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <Modal className="teamdetails popupForm" backdrop="static" size="lg" show={this.state.showForm} onHide={() => { this.openform(false) }}>
                    <Modal.Header closeButton>
                      <Modal.Title> <div className="form__head">
                        <h4>Subscribe to Catalogue</h4>
                      </div>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <SubscribetoCatalogueForm page="auction-search-result"
                      />
                    </Modal.Body>

                  </Modal>
                  {this.state?.viewType === "list" ? <>
                    <CustomInfiniteHits
                      auctionType={this.props.auctionType}
                      location={this.props.fullpathname}
                      tag={this.props.ptypetag}
                      hits={this.props?.hits}
                      page={this.props?.page_url_data?.pageVal}
                      hasMore={(this?.props?.total > this?.props?.hitsPerPage) && (parseInt(this.props?.page_url_data?.pageVal)) !== this.props?.number_of_pages}
                    />
                    <NoStats map={this.state?.viewType ? true : false} ptype={this.props.ptype} nbHits={this.props?.total} auctions={true} />
                    {/* <CustomNoStats ptype={this.props.ptype} auctions={true} /> */}
                  </>
                    : this.state?.viewType === "map" ?
                      <div className="map-bk">
                        <div className="grid-view home-properties d-none d-lg-flex">
                          <CustomInfiniteHits
                            auctionType={this.props.auctionType}
                            location={this.props.fullpathname}
                            tag={this.props.ptypetag}
                            // map={this.state?.viewType ? true : false}
                            hits={this.props?.hits}
                            page={this.props?.page_url_data?.pageVal}
                            hasMore={(this?.props?.total > this?.props?.hitsPerPage) && (parseInt(this.props?.page_url_data?.pageVal)) !== this.props?.number_of_pages}
                            map="true"
                          />
                          <NoStats map={this.state?.viewType ? true : false} ptype={this.props.ptype} nbHits={this.props?.total} auctions={true} />
                          {/* <CustomNoStats ptype={this.props.ptype} auctions={true} /> */}
                        </div>

                        {!isMobile && (
                          <div className="map-view d-none d-lg-block map-view-wrap">
                            <MapResultsDesktop
                              ptype={
                                this.props.ptype === "sales" &&
                                  this.props.pcategorytype === "residential"
                                  ? "myResSaleProp"
                                  : this.props.ptype === "lettings" &&
                                    this.props.pcategorytype === "residential"
                                    ? "myResRentProp"
                                    : ""
                              }
                              hits={this.props?.hits}
                            />
                          </div>
                        )}
                        {isMobile && this.state?.viewType === "map" &&
                          (
                            <div className="map-view d-block d-lg-none map-view-wrap">
                              {/* <Configure hitsPerPage={isMobile && this.state?.viewType === "map" ? 1000 : 16} /> */}
                              <MobileResultsDesktop ptype={
                                this.props.ptype === "sales" &&
                                  this.props.pcategorytype === "residential"
                                  ? "myResSaleProp"
                                  : this.props.ptype === "lettings" &&
                                    this.props.pcategorytype === "residential"
                                    ? "myResRentProp"
                                    : ""
                              }
                              hits={this.props?.hits} />
                              </div>
                            )}
                      </div>
                      : null}
                </Container>

              </div>


            </div>
          {/* </InstantSearch> */}

        </section>
      </Layout>
    )
  }
}

const PropertySearchSalesWrap = (props) => {
  return (
    <GlobalContext.Consumer>
      {globalProps => {
        return (
          <AuctionPropertySearchSales {...props} {...globalProps} />
        )
      }}
    </GlobalContext.Consumer>
  )
}

export default PropertySearchSalesWrap;
